// extracted by mini-css-extract-plugin
export default {"container":"AllArticles_container__yMYAy","title_container":"AllArticles_title_container__NQdaF"};